export enum StatisticLevel {
  good = 2,
  average = 1,
  bad = 0
}
